import { useEffect, useState, MutableRefObject } from 'react';
import mixpanel, { trackedEvents } from 'app/utils/mixpanel';
import useOnScreen from './useOnScreen';

const useTrackSmartFeed = <T extends Element>(
  ref: MutableRefObject<T>,
  trackInterval: number,
  trackParams: {
    feed: string;
    param: 'post' | 'opinion';
    param_id: number;
  },
) => {
  const [tracked, setTracked] = useState(false);
  const { isOnScreen } = useOnScreen<T>(ref, 200);

  useEffect(() => {
    const selectedTrackPageType = ['home', 'trending', 'article'];
    const handler = setTimeout(() => {
      if (
        isOnScreen &&
        !tracked &&
        selectedTrackPageType.includes(trackParams.feed)
      ) {
        setTracked(true);
        mixpanel.track(trackedEvents.FeedScrollFocused, trackParams);
      }
    }, trackInterval);
    return () => {
      clearTimeout(handler);
    };
  }, [isOnScreen, trackInterval, tracked, trackParams]);
};

export default useTrackSmartFeed;
